import React, { Fragment } from 'react';
import Header from './Header';
import Footer from './Footer';
import Scroll from './Scroll';

const AppLayout = (props) => {
  return (
    <Fragment>
      <Header />
      <div className="content">{props.children}</div>
      <Footer />
      <Scroll />
    </Fragment>
  )
}

export default AppLayout;